import generatePicker from 'antd/es/date-picker/generatePicker';
import 'dayjs/locale/zh-cn';
import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';

// import 'antd/lib/date-picker/style/index';

export const DatePicker = generatePicker(dayjsGenerateConfig);
